import moment from "moment";

class Summary {
	constructor(config) {

		this.config = Object.assign({
			scope: '.summary.page'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.on('click', '[data-scope="summary-orderrows"] .destroy', this.deletePlacement.bind(this));
		this.$modal = $('#bootstrapModal');
		this.$modal.on('shown.bs.modal', function () {
			this.initDatepickers();
		}.bind(this));
		this.$modal.on('hidden.bs.modal', function() {
			window.location.reload();
		});
	}

	async deletePlacement(event) {
        let url = $(event.currentTarget).data('href');

        let res = await $.delete(url, function (data) {
            jQuery('[data-scope="summary-sidebar"]').html(data.sidebar);
            jQuery('[data-scope="summary-orderrows"]').html(data.orderrows);
            if (data.totalorderrows == 0) {
                location.href="/krant-selecteren"
            }
        });
        event.stopPropagation()
	    return false;
    }

	initDatepickers() {
		let enabledDates = this.$modal.find('#placement').data('enabled-dates').split(',');
		function formatDate(d) {
			var day = String(d.getDate())
			//add leading zero if day is is single digit
			if (day.length == 1)
				day = '0' + day
			var month = String((d.getMonth()+1))
			//add leading zero if month is is single digit
			if (month.length == 1)
				month = '0' + month
			return day + "-" + month + "-" + d.getFullYear()
		}

		let datepickerConfig = {
			beforeShowDay: function(date){
				if (enabledDates.indexOf(formatDate(date)) < 0)
					return {
						enabled: false
					}
				else
					return {
						enabled: true
					}
			},
			format: 'dd-mm-yyyy',
			inline: true,
			language: 'nl',
			multidate: false,
			maxViewMode: 0
		};

		this.$modal.find('#placement').datepicker({
			...datepickerConfig,
			startDate: moment().format('DD-MM-yyyy'),
		})

		this.$modal.off('changeDate', '#placement');
		this.$modal.on('changeDate', '#placement', this.publicationDateChanged.bind(this));
	}

	publicationDateChanged(e) {
		let datePlacement = this.$modal.find('#placement').data('datepicker').getDate();
		let dateFormatted = moment(datePlacement).format('DD-MM-yyyy');
		let uniqid = this.$modal.find('input[name=uniqid]').val();
		let obj = {
			publication_date: dateFormatted
		};
		let res = $.post('/uw-advertentie/publicatie-selectie/'+uniqid+'/change-date', obj, function (data) {
			window.location.reload();
		});
	}
}

export default Summary;
